module.exports = "/_next/static/images/9b99390cc55781400133be172d8cb382-payment_swipe.png";